import React from 'react';
import styles from './ArticlesList.module.scss';
import { Article } from '../article';
import { ProductInfo } from '../../../model/product';

export type ArticlesListProps = {
  articles: ProductInfo[];
};

export const ArticlesList = (props: ArticlesListProps) => {
  return (
    <div className={styles.listWrapper}>
      {props.articles.map((article) => (
        <Article key={`article-${article.articleShopId}`} article={article} />
      ))}
    </div>
  );
};
